module.exports = __webpack_public_path__ + "img/252.13bf63d1.jpg";